import React, { FC, forwardRef } from 'react';
import { DialogTitleProps, Typography, IconButton, Box } from '@mui/material';
import { CloseIcon } from '@/src/components/icon/stroke/CloseIcon';

/**
 * This component serves as an extended title section for a dialog,
 *  including an optional close button displayed when `onClose` prop is provided.
 */
export const FlowDialogTitle: FC<DialogTitleProps> = forwardRef(
  ({ onClose, closeIconButtonProps, children, ...rest }, ref) => {
    const { sx: closeIconButtonSx, ...restCloseIconButton } = closeIconButtonProps ?? {};

    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: children ? 'space-between' : 'flex-end',
          alignItems: 'flex-start',
          gap: 1,
          overflow: 'hidden',
        }}
      >
        {children && (
          <Typography component="h2" ref={ref} {...rest}>
            {children}
          </Typography>
        )}
        {onClose && (
          <IconButton
            size="medium"
            onClick={(e) => onClose(e, 'backdropClick')}
            aria-label="Close"
            sx={{
              // move to the right side
              marginRight: '16px',
              marginTop: '16px',
              ...closeIconButtonSx,
            }}
            {...restCloseIconButton}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    );
  },
);
